"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = checkObjectType;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _seempleerror = _interopRequireDefault(require("./seempleerror"));

// checks type of a variable and throws an error if its type is not an object
function checkObjectType(object, method) {
  var typeofObject = object === null ? 'null' : (0, _typeof2["default"])(object);

  if (typeofObject !== 'object' && typeofObject !== 'function') {
    throw (0, _seempleerror["default"])('common:object_type', {
      object: object,
      method: method
    });
  }
}
//# sourceMappingURL=checkobjecttype.js.map